export default __webpack_public_path__ + "static/media/portolifo_left.a33408b9.svg";